import { render, staticRenderFns } from "./GatewayRender.vue?vue&type=template&id=32eb8f3d&"
import script from "./GatewayRender.vue?vue&type=script&lang=js&"
export * from "./GatewayRender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports